import styled from "styled-components";
import { IoClose } from "react-icons/io5";
import { HiTrash } from "react-icons/hi";

export const Background = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: ${(props) => (props.Show ? "flex" : "none")};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;

  &:before {
    z-index: 1;
    content: "";
    width: 100%;
    height: 100%;
    background-color: var(--blur-bg-color);
    position: fixed;
    top: 0;
    left: 0;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  padding: 50px 50px 20px;
  border-radius: 5px;
  background-color: var(--secondary-bg-color);
  gap: 20px;
  max-width: 95%;
  width: fit-content;
  min-width:500px;

  .encaminharOcorrencia{
    display: flex;
    align-items: center;
    margin-right: auto;
    margin-left: 8%;
    font-size: 16px;
    max-width:85%;
    width: 100%;
    font-size: 16px;

    label{
      padding-left: 10px;
    }
    .checkEncaminhar{
      font-size:5px;
      transform: scale(1.5);
    }

  }
`;

export const Title = styled.h1`
  color: var(--primary-font-color);
`;

export const Button = styled.button`
  width: 45%;
  border: none;
  height: 40px;
  border-radius: 5px;
  padding: 10px 40px;
  background-color: var(--main-color);
  color: var(--button-text-color);
  cursor: pointer;
  text-transform: uppercase;
  font-weight: 800;
  transition: transform 0.5s;
  transition: box-shadow 0.5s;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.5);
  }
`;

export const CloseIcon = styled(IoClose)`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 40px;
  transition: transform 0.2s;
  color: var(--second-auxiliary-color);

  &:hover {
    transform: scale(1.2);
  }
`;

export const AnexosContainer = styled.div`
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  position: relative;
  border: 1px solid var(--second-auxiliary-color);

  span {
    display: grid;
    gap: 5px 0;
    grid-template-columns: 1fr auto;
  }
`;

export const AnexoTitle = styled.h4``;

export const RemoveIcon = styled(HiTrash)`
  font-size: 20px;
  cursor: pointer;
  position: relative;

  &:hover {
    transform: scale(1.2);
    color: var(--main-color);
  }
`;
